// src/components/InstallationsTable.js
import React, { useEffect, useState } from "react";
import { getInstallations } from "../api";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ import function directly

function InstallationsTable() {
  const [installations, setInstallations] = useState([]);
  const [facilityFilter, setFacilityFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    getInstallations().then(setInstallations);
  }, []);

  // Apply filters
  const filteredInstallations = installations.filter(i => {
    const matchesFacility = facilityFilter ? i.facility === facilityFilter : true;
    const matchesStart = startDate ? new Date(i.date) >= new Date(startDate) : true;
    const matchesEnd = endDate ? new Date(i.date) <= new Date(endDate) : true;
    return matchesFacility && matchesStart && matchesEnd;
  });

  // ✅ Export to Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredInstallations);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Installations");
    XLSX.writeFile(workbook, "Installations.xlsx");
  };

  // ✅ Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Installations Report", 14, 10);

    autoTable(doc, {
      head: [["Facility", "Product", "Date", "Cost"]],
      body: filteredInstallations.map(i => [
        i.facility,
        i.product,
        new Date(i.date).toLocaleDateString(),
        i.cost,
      ]),
      startY: 20,
    });

    doc.save("Installations.pdf");
  };

  return (
    <div style={{ marginTop: "24px" }}>
      <h2>Installations</h2>

      {/* Filters */}
      <div style={{ marginBottom: "10px" }}>
        <label>
          Filter by Facility:{" "}
          <select
            value={facilityFilter}
            onChange={e => setFacilityFilter(e.target.value)}
          >
            <option value="">All Facilities</option>
            <option value="Peshawar Central Hospital">Peshawar Central Hospital</option>
            <option value="Karachi General Hospital">Karachi General Hospital</option>
          </select>
        </label>

        <label style={{ marginLeft: "20px" }}>
          Start Date:{" "}
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
          />
        </label>

        <label style={{ marginLeft: "20px" }}>
          End Date:{" "}
          <input
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
          />
        </label>
      </div>

      {/* Table */}
      <table border="1" width="100%" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Facility</th>
            <th>Product</th>
            <th>Date</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody>
          {filteredInstallations.map(i => (
            <tr key={i._id}>
              <td>{i.facility}</td>
              <td>{i.product}</td>
              <td>{new Date(i.date).toLocaleDateString()}</td>
              <td>{i.cost}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Export buttons */}
      <div style={{ marginTop: "10px" }}>
        <button onClick={exportToExcel}>Export to Excel</button>
        <button onClick={exportToPDF} style={{ marginLeft: "10px" }}>
          Export to PDF
        </button>
      </div>
    </div>
  );
}

export default InstallationsTable;
